import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class LiquidacionRecorridoService {
  constructor(private gqlclient: GraphQLClient) {}

  cerrarLiquidacion(
    inputParams: {
      rutEmpresa: number;
      sucursalCodigo: number;
      codigoRecorrido: number;
      monto: number;
      saldoDocumentoCliente: any;
      rutUsuario: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigoRecorrido: Decimal, $monto: Decimal, $rutUsuario: Decimal, $saldoDocumentoCliente: [recorrido_detalleInputType]) {
            liquidacion_recorrido {
              cerrarLiquidacion(
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                codigoRecorrido: $codigoRecorrido
                monto: $monto
                rutUsuario: $rutUsuario
                saldoDocumentoCliente: $saldoDocumentoCliente
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.liquidacion_recorrido.cerrarLiquidacion;
        callback({ mensajes, respuesta });
      }
    );
  }
}
